import { useNavigate } from "react-router-dom";
import style from "../styles/checkout-pages.module.scss";

function FailIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

export default function CheckoutFail() {
  const navigate = useNavigate();

  return (
    <div className={style.page}>
      <div className={style.card}>
        <div className={style.iconWrapFail}>
          <FailIcon />
        </div>

        <h1 className={style.heading}>Payment Unsuccessful</h1>
        <p className={style.subheading}>
          We weren't able to process your payment. Your card has not been charged.
        </p>

        <div className={style.divider} />

        <p className={style.failNote}>
          This can happen if your card was declined, your session timed out, or you cancelled at checkout. Please try again or contact your payment provider if the issue continues.
        </p>

        <div className={style.actions}>
          <button className={style.primaryBtn} onClick={() => navigate("/book-now")}>
            Try again
          </button>
          <a href="/contact-us" className={style.secondaryLink}>Need help? Contact us</a>
        </div>
      </div>
    </div>
  );
}
